import _ from 'lodash';
import { useEffect } from 'react';

export const setCustomerFromQueryParams = ({ Cart, queryParams }) => {
  const params = {};

  _.forEach(_.keys(queryParams), (key) => {
    if (_.startsWith(key, 'dtche')) {
      const dtcheKey = key.match(/\[(.*?)\]/)?.[1];
      if (dtcheKey) {
        params[dtcheKey] = queryParams[key];
      }
    } else {
      params[key] = queryParams[key];
    }
  });

  const { birthdate, email, firstName, lastName, medCardExpiration, medCardNumber, medCardState, phone } = params;

  const guestCustomerObj = _.omitBy(
    {
      firstName,
      lastName,
      phone,
      email,
      birthMonth: _.slice(birthdate, 0, 2).join(''),
      birthDay: _.slice(birthdate, 2, 4).join(''),
      birthYear: _.slice(birthdate, 4, 8).join(''),
    },
    _.isEmpty
  );

  _.mapKeys(guestCustomerObj, (value, key) => Cart.updateGuestCustomer(key, value));

  if (medCardNumber) {
    Cart.setMedicalCardNumber(medCardNumber);
  }
  if (medCardExpiration) {
    Cart.setMedicalCardExpiration(medCardExpiration);
  }
  if (medCardState) {
    Cart.setMedicalCardState(medCardState);
  }
};

export const useCustomerFromQueryParams = ({ Cart, queryParams }) => {
  useEffect(() => {
    setCustomerFromQueryParams({ Cart, queryParams });
  }, [Cart, queryParams]);
};
